import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function ReaderValue() {
  const readerStates = ['Interested, but not ready for a call', 'Trying to apply one idea', 'Needs the right next step'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-496" data-mp="3or149ngmztgd">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-497" data-mp="3ooencx7uw1lh">
        <PathThread data-id="element-498" data-mp="pa2vip50004q" />
      </div>

      <div className="text-center mb-20" data-id="element-499" data-mp="p91hqcwlkzjb">
        <Reveal data-id="element-500" data-mp="l9ixzkgiiui2">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-501" data-mp="lb3q73fcu1cr">
            Some readers are not ready to buy. <br data-id="element-502" data-mp="g8uysbi4r7cr" />
            <span className="italic text-seaglass" data-id="element-503" data-mp="gcin8w8px3km">
              But they are ready to keep going.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-504" data-mp="311yflvnl50cd">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-505" data-mp="31281b71lklc9">
            <p data-id="element-506" data-mp="2w0ir1tm78bp8">
              A reader can be interested without being ready to book a call.
            </p>
            <ul className="space-y-3 text-left max-w-lg mx-auto bg-white p-6 rounded-2xl shadow-[0_8px_20px_-12px_rgba(26,40,56,0.1)] border border-gray-100" data-id="element-507" data-mp="3a6ik0ol4wh0z">
              <li className="flex items-start gap-3" data-id="element-508" data-mp="309e06vergxnc">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-509" data-mp="359jrubl16k5f"></div>
                They may need to understand where they fit.
              </li>
              <li className="flex items-start gap-3" data-id="element-510" data-mp="2qija1fye9dwm">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-511" data-mp="2vbm3zp732pdc"></div>
                They may need to try the idea in their own situation.
              </li>
              <li className="flex items-start gap-3" data-id="element-512" data-mp="2miivzwf7j4q3">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-513" data-mp="2mjak6m6h606c"></div>
                They may need to see whether the framework applies to their
                team.
              </li>
              <li className="flex items-start gap-3" data-id="element-514" data-mp="2cmpc1rz5s8ya">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-515" data-mp="1thazl1dklmlx"></div>
                They may need language for the problem before they are ready to
                ask for help.
              </li>
            </ul>
            <p className="font-serif text-2xl text-navy pt-6" data-id="element-516" data-mp="1jo3nyys8lade">
              The path after the book gives them a useful next step before they
              are ready for a sales conversation.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-24" data-id="element-517" data-mp="27h2b8vgm6qwr">
        {readerStates.map((state, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-518" data-mp="22g4tul3fi0wb" data-mpi={idx}>
            <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center shadow-[0_12px_24px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex items-center justify-center min-h-[120px]" data-id="element-519" data-mp="22j0rs9fa0pkr">
              <span className="font-serif text-lg text-navy" data-id="element-520" data-mp="m26ajfsprv8b">{state}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-521" data-mp="2xr2tlp574dzo">
        <div id="quick-check-3" className="scroll-mt-32" data-id="element-522" data-mp="2xrum2r3hxvlq">
          <ReaderPathCheck questionId="q4.apply.thisWeek" checkLabel="Quick Check · 3 of 8" confirmationText="Saved. This helps check whether the book gives readers a useful next step." data-id="element-523" data-mp="32ocr7s2qnvyl" />
          
        </div>
      </Reveal>
    </section>;
}